<template>
    <div class="headerCompany">
      <h1>{{ $t('companies.label.list.title') }}</h1>
  
      <v-data-table 
        :headers="headers" 
        :items="empresas" 
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>
  
              <div class="btn">
                <addCompanies />
              </div>
            </div>
          </div>
        </template>
        
        <template v-slot:[`item.icon`]="{ item }">   
          <img :src="item.icon"/>  
        </template>
        
        <template v-slot:[`item.name`]="{ item }">
          <span class="custom-font">{{ item.name }}</span>
        </template>
  
        <template v-slot:[`item.identificationNumber`]="{ item }">
          <span class="custom-font">{{ item.identificationNumber }}</span>
        </template>
  
        <template v-slot:[`item.contactName`]="{ item }">
          <span class="custom-font">{{ item.contactName }}</span>
        </template>
  
        <template v-slot:[`item.contactNumber`]="{ item }">
          <span class="custom-font">{{ item.contactNumber }}</span>
        </template>
  
        <template v-slot:[`item.action`]="{ item }">
          <!-- Botón de acción para abrir el diálogo de detalles  -->
          <v-icon
            color="primary"
            size="x-large"
          ></v-icon>
          
          <div class="actions">
  
            <detailsCompany
                :status="item.activeDialogClient"
                :companyProps="item"
                :disableComission= true
                style="margin-left:1vh"
              ><v-btn
             
                icon    
                x-large
                dark
                text
                >             
                <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
            </detailsCompany>

            <v-btn
              class="btnDetails"
              icon    
              x-large
              dark
              text
              @click = "deleteCompany(item.companyId)"
              style="background-color: transparent; margin-left:1vh"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
  
      </v-data-table>
  
    </div>
  </template>
  
  <script>
  import addCompanies from "@/views/companies/pages/add_companies/add_companies_page.vue";
  import detailsCompany from "@/views/companies/pages/detail_companies/detail_company_page.vue";
  import  EventBus  from '@/utils/event_bus.js'; 
  import { mapActions, mapGetters } from "vuex";
  import i18n from '@/plugins/i18n';
  import Swal from "sweetalert2";
  
  import {
    COMPANIES_M,
    GET_COMPANIES,
    ACTION_GET_COMPANIES,
    ACTION_DELETE_COMPANIES,
  } from "@/views/companies/store/types/types.js";
  
  export default {
    name: "listCategoriaComponent",
    components: {
      addCompanies,
      detailsCompany
    },
  
    data() {
      return {
        searchTerm: "",
      };
    },
  
    async mounted() {
  
      await this.getActionCompany();
  
      EventBus.$on('reload-company', async () => {
        await this.reloadCompany();
      });
  
      EventBus.$on('formCompany-submitted-successfully', async () => {
        await this.reloadCompany();
      });

      EventBus.$on('reload-update-company', async () => {
        await this.reloadCompany();
      });      
      
    },
  
    methods: {
  
      ...mapActions({
        getActionCompany: `${COMPANIES_M}${ACTION_GET_COMPANIES}`,
        deleteActionCompanies: `${COMPANIES_M}${ACTION_DELETE_COMPANIES}`,
      }),
  
      async reloadCompany() {
        await this.getActionCompany();
      },
  
      
  
      search() {
        // Actualiza el término de búsqueda
        this.searchTerm = event.target.value;
      },
  
      async deleteCompany(companyId) {
          const result = await Swal.fire({
            title: i18n.t('label.delete.title'),
            text: i18n.t('label.delete.text'),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: i18n.t('button.delete.accept'),
            cancelButtonText: i18n.t('button.delete.cancel'),
            confirmButtonColor: "#6E17A5"
          });
  
          if (result.isConfirmed) {
            
            await this.deleteActionCompanies(companyId);
            this.getActionCompany()
            // await this.reloadCompany();
            
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: i18n.t('label.delete.cancel'),
              showConfirmButton: false,
              timer: 2500
            }); 
          }
      },
  
    },
  
    computed: {
  
      ...mapGetters({
        empresas: [`${COMPANIES_M}${GET_COMPANIES}`],
      }),
  
      headers() {
        return [
          {
            value: "icon",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('companies.label.table.company'),
            value: "name",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('companies.label.table.identification'),
            value: "identificationNumber",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('companies.label.table.nameContact'),
            value: "contactName",
            sortable: false,
            align: "center",
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('label.phone.title'),
            value: "contactNumber",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            //text: "Acciones",
            value: "action",  // Cambiado de 'action' a 'actions'
            sortable: false,
            align: "center",
            //class: "primary--text custom-header mdi-pencil text-subtitle-1",
          },
        ];
      }, 
    },
    
  };
  </script>
  
  <style lang="css" scoped>
  
    .headerCompany h1 {
      margin-bottom: 30px;
    }
  
    .headerCompany {
      display: flex;
      gap: 40px;
      flex-direction: column;
      margin-top: 20px;
      margin-left: 20px;
    }
  
    .actions v-icon {
      font-size: 24px;
    }
    .custom-font {
      font-size: 20px;
    }
    /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
    body {
      font-family: "Nunito Sans", sans-serif;
    }
    
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Amsi Pro", sans-serif;
      color: #2d0049;
      font-weight: normal;
    }
  /* Estilos para el botón de eliminar */
    .btnDetails .v-icon {
      color: #6E17A5;
      margin-bottom: 19px;
    }
  
    /**estilo de los iconos */
    .actions{
      display:flex;
         
    }

    /* .marginIcon{
      margin-top: 12;
    } */
  
    img{
      width: 3rem;
      height: 3rem;
    }
  
    @media screen and (max-width: 414px) {
          
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          .custom-font{
            font-size: 13px;
          }
          img{
            margin-top: 18px;
            margin-bottom: auto;
            width: 3rem;
            height: 3rem;
          }
      }
  
      @media screen and (min-width: 414px) {
          
          h1{
              font-size:4vh;
              margin-left:2vh
          }
        
      }
   
      @media screen and (max-width: 280px) { 
  
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          h2{
              font-size:2vh;
          }
          .custom-font{
            font-size: 13px
          }
          img{
            margin-top: 20px;
            margin-bottom: 10px;
            width: 3rem;
            height: 3rem;
          }
      } 
  
  </style>
  